import { render, staticRenderFns } from "./Absences.vue?vue&type=template&id=0a3edc8b&"
import script from "./Absences.vue?vue&type=script&lang=js&"
export * from "./Absences.vue?vue&type=script&lang=js&"
import style0 from "./Absences.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports